import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../actions/CompanyManagementOrganizer';
import DialogEditCompanyOrganizer from '../../pages/CompanyManagementOrganizer/DialogEditCompanyOrganizer';
import DetailCompanyOrganizerSelector from '../../selectors/DetailCompanyOrganizer';
import { GetJobsRequested, GetOccupationRequest, GetCategoryRequest, ClearOccupation } from '../../actions/CommonOptions';

const detailCompanyRespone = DetailCompanyOrganizerSelector.createDetailCompanyOrganizerResultsSelector();
const mapStateToProps = (state) => {
    const isLoading = state.companyManagementOrganizer.detailCompanyOrganizer.isFetching
    || state.companyManagementOrganizer.editCompanyOrganizer.isFetching;
    return ({
        locale: state.locale.lang.current,
        isAuthorized: state.auth.credential.isAuthorized,
        detailCompanyOrganizer: detailCompanyRespone(state),
        editSuccess: state.companyManagementOrganizer.editCompanyOrganizer.success,
        editErrors: state.companyManagementOrganizer.editCompanyOrganizer.errors,
        eventInfo: state.registration.registrationViewer.data,
        options: state.commonOptions.Options.data,
        jobs: state.commonOptions.jobs.data,
        zones: state.commonOptions.zones.data,
        isLoading,
        customText: state.adminSettingCustom.getCustomText.data || {},
        occupations: state.commonOptions.occupations.data,
        category: state.commonOptions.category.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchGetDetailCompanyOrganizer: () => {
        dispatch(Action.GetDetailCompanyOrganizerRequested());
    },
    fetchClearGetDetailCompanyOrganizer: () => {
        dispatch(Action.ClearGetDetailCompanyOrganizer());
    },
    fetchEditCompanyOrganizerRequested: (params) => {
        dispatch(Action.EditCompanyOrganizerRequested(params));
    },
    fetchClearEditCompanyOrganizer: () => {
        dispatch(Action.ClearEditCompanyOrganizer());
    },
    fetchJobs: (shortName) => {
        dispatch(GetJobsRequested(shortName));
    },
    fetchCategory: (shortName) => {
        dispatch(GetCategoryRequest(shortName));
    },
    getOccupations: (param) => {
        dispatch(GetOccupationRequest(param));
    },
    clearOccupations: () => {
        dispatch(ClearOccupation());
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DialogEditCompanyOrganizer);
